import { useEffect, useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Tab1 from "./Tab1";
import { Box, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MJourFerier';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";
import { fetchDataTable, fetchDataTable2, normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";
import User from "../ManageUser/User";
import Banque from "../../../Models/Banque";
import JourFerier from "../../../Models/MJourFerier";
import { Direction } from "react-toastify/dist/utils";



const CreateFerier = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(false);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [DataBranch, SetDataBranch] = useState<JourFerier[]>([]);
        const [currentDataBranch, setCurrentDataBranch] = useState<JourFerier | null>(null);
          
         const [searchTerm, setSearchTerm] = useState('');
        const [page, setPage] = useState(0); // Page actuelle
         const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
         const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
     

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        setIdbutton(true)
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')
        setIdbutton(false)
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        setIdbutton(true)
        
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
    }

// 📄 Filtrage des données en fonction du terme de recherche
  const filteredDataBranch = DataBranch.filter((item) =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  // 📄 Pagination après filtrage
  const paginatedDataBranch = filteredDataBranch.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
// --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
  const handleOpenDialog = (DataToEdit: JourFerier | null = null) => {
    if (DataToEdit) {
      setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
      form.setFieldsValue({...DataToEdit})
      HandleModif()
     // console.log(DataToEdit)
    } else {
      // Initialiser un nouvel objet avec des valeurs par défaut
      setCurrentDataBranch({
    LINE:	0,
    DATEJOUR:	new Date(Perss.datjour) ,
    INTITULE:'',
    DATCRE:new Date(Perss.datjour),
    DATMODIF:	new Date(Perss.datjour),
    UTILIS:	Perss.coduti,
    
      });
    }
   // setOpenDialog(true);
   // setDialogError(null); // Réinitialiser les erreurs du dialogue
  };

  useEffect(() => {
      loadAllDataBranch();
  }, []);
 
    async function loadAllDataBranch() {
      
         setLoading2(true);
        setError(null);
        try {
     // console.log(apiEndpoints.bureaux)
      var params = { CodeAgence: '' , Table: "JOUR_FERIES", Colonne1: "DATEJOUR", Colonne2: "INTITULE", Colagence: "", Init: "", choix: 22, colfiltre: "", valfiltre: "" }

      const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
     if (data.length!==0)
         {
    // alter(data.result)
      console.log(data)
      SetDataBranch(normalizeKeysToUppercase(data)); // ou console.log(data)
         }
      }catch (err) {
      console.error("Erreur de chargement:", err);
      setError("Impossible de charger les données .");
     } finally {
      setLoading2(false);
     }
    }
// 🔁 Gestion du changement de page
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // 🔁 Gestion du changement de nombre de lignes
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Revenir à la première page après changement
  };


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Création Fériée
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <legend> Mise en place des jours Fériés </legend>
                            
                            <Box style={{ marginTop: -10,display:'flex',width: '100%'  }}>
                                 <fieldset className="bordure1"  >
                                    <Box style={{ width: '100%'}}>
                                        <InputForm width={0} label="Date Fériée" type="date" name="DATEJOUR" taille={180} />
                                       <InputForm width={0} label="Intitulé Fériée" type="texte" name="INTITULE" taille={400} />
                                    </Box>                                                                 
                               
                                 </fieldset>
                               
                            </Box>


                                   <Box style={{ width: '100%' }}>
                                    <fieldset className="bordure1"  >
                                        {/* Zone de recherche */}
                                              <Box sx={{ mb: 2 }}>
                                                <TextField
                                                  label="Recherche"
                                                  variant="outlined"
                                                  fullWidth
                                                  
                                                  value={searchTerm}
                                                   onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(0); // Remettre à la page 0 après recherche
                                                  }}
                                                  size="small"
                                                  InputLabelProps={{
                                                      sx: {
                                                        fontWeight: 'bold',
                                                              },
                                                             }}
                                                  InputProps={{
                                                     endAdornment: (
                                                     <InputAdornment position="end">
                                                     <SearchIcon color="action" />
                                                     </InputAdornment>
                                                                 ),
                                                             }}
                                                />
                                               
                                              </Box>
                                              
                                         <TableContainer component={Paper} elevation={3} sx={{
                                              // --- Styles pour les ascenseurs ---
                                              maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                                              overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                                              overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                                              width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                                              minWidth: '800', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                                            }}>
                                                
                                            <Table stickyHeader size="small" >
                                              <TableHead  >
                                                <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Line </TableCell>
                                                 
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Date jour</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Intitulé</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée le</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée par</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Actions</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {paginatedDataBranch.length === 0 ? (
                                                  <TableRow>
                                                    <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                                                  </TableRow>
                                                ) : (
                                                  paginatedDataBranch.map((item,index) => (
                                                    <TableRow   key={`${item.LINE}-${item.DATEJOUR}-${item.INTITULE}`}  sx={{
                                                     cursor: 'pointer',
                                                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                                     '&:hover': {
                                                      // backgroundColor: '#e0f7fa', // Couleur au survol
                                                     // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                                      //color: '#fff', // Texte blanc sur fond sombre
                                                      background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                        },
                                                             }} > 
                                                     {/* Clé unique pour React */}
                                                      <TableCell sx={{ py: 0 }}>{item.LINE}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.DATEJOUR ? new Date(item.DATEJOUR).toLocaleDateString() : 'N/A'}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.INTITULE}</TableCell>
                                                      <TableCell sx={{ py: 0 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                                                      <TableCell sx={{ py: 0 }}>{item.UTILIS ?? 'N/A'}</TableCell>
                                                     
                                                      <TableCell sx={{ py: 0 }}>
                                                        <IconButton color="primary" onClick={() => handleOpenDialog(item)}>
                                                          <EditIcon />
                                                        </IconButton>
                                                        <IconButton color="error" onClick={() => HandleSupp()}>
                                                          <DeleteIcon />
                                                        </IconButton>
                                                      </TableCell>
                                                    </TableRow>
                                                  ))
                                                )}
                                              </TableBody>
                                            </Table>
                                        </TableContainer>
                                         {/* Pagination */}
                                              <TablePagination
                                                component="div"
                                                count={filteredDataBranch.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                labelRowsPerPage="Lignes par page"
                                              />
                                    </fieldset>
                                 </Box>
                             
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];

     // function consult 
     function consult() {
        loadAllDataBranch();
        // if (form.getFieldValue("DateJour") == null) {
        //     SweetAlert.fire({ title: "Svp renseigner la date du jour férier", icon: "warning" });
        // } else {
        //     //HandleConsult()
        //     let data = formatDate(form.getFieldValue("DateJour"));

        //     alert(data)

        //     if (data.length != 0) {
        //         setLoading(true)
        //         let config = {
        //             method: 'get',
        //             maxBodyLength: Infinity,
        //             url: Data.ApiUrl.ReadJrFerier,
        //             headers: {
        //                 'CypherFerier': data,
        //                 'Authorization': authHeader(),
        //                 'Content-Type': 'application/json'
        //             },
        //         };

        //         alert(data)

        //         axios.request(config)
        //             .then((response) => {
        //                 setLoading(false);
        //                 alert(data)
        //                 if (response.data) {
        //                     //const res = JSON.parse(Crypter.decrypt(response.data));
        //                     const res = JSON.parse(Crypter.decrypt(response.data));
        //                     //console.log(JSON.stringify(res))
        //                     let DemandVP = res.Result.Table[0]
        //                     console.log(DemandVP);

        //                     if (res.StatutCode == 200) {

        //                         form.setFieldsValue(DemandVP);
        //                         form.setFieldValue("lib_NODECE", DemandVP.LECEON)

        //                     }
        //                     else {
        //                         SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
        //                     }
        //                 }
        //                 setLoading(false)
        //             })
        //             .catch((error) => {
        //                 setLoading(false);
        //                 console.log(error)
        //                 SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        //             });
        //     }
        // }
    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: Demand = values
        Demand.DATCRE = new Date(formatDate(Perss.datjour)) ;
        Demand.DATMODIF = Demand.DATMODIF;
        Demand.UTILIS = Perss.coduti;
        

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un Jour Ferier ",
                text: "Voulez-vous Créer le jour ferier intitulé :" + form.getFieldValue("Intitule"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateJrFerier,
                        headers: {
                            'CypherFerier': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result
                                console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        //HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Modification d'un Jour Ferier ",
                text: "Voulez-vous Modifier le jour ferier intitulé :" + form.getFieldValue("Intitule"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateJrFerier,
                        headers: {
                            'CypherFerier': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    
                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        //HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'un Jour Ferier ",
                text: "Voulez-vous Supprimer le jour ferier intitulé :" + form.getFieldValue("Intitule"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteJrFerier,
                        headers: {
                            'CypherFerier': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    
                                    if (code ==     'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        //HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Interêt et Commission : {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button> */}
                                <Button size='large' disabled={Annulactv} onClick={() => {form.resetFields(); HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default CreateFerier;